import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6a1b3c28"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-wrap" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tips" }, " 领取三责险仅支持睿运吊运（挂钩）和睿运舱运 （舱体），无人机三责险需要在设备激活时领取。 ", -1))
const _hoisted_3 = { class: "input-item" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "序列号", -1))
const _hoisted_5 = { class: "button-wrap nongfu-button-wrap" }

import { ref } from 'vue'
import { Field, Button } from 'vant'
import { useRouter } from 'vue-router'
import { getErrorMessage, commonErrorHandle } from '@/utils/error-handle'
import { useThreeLiabilityFunction } from '@/compositions/insurance/index'
import { showToastLoading, clearToast, showConfirmModal } from '@/utils/tools'
import {
  getSnCanReceiveRuiyunInfo,
  requestContactSnAndThreeLiabilityInsurance,
} from '@/apis/insurance'
import Header from '@/components/Header.vue'
import { showToastSuccess } from '@/utils/tools'


export default /*#__PURE__*/_defineComponent({
  __name: 'free-receive',
  setup(__props) {

const sn = ref('')
const $router = useRouter()
const { getReceiveThreeLiabilityUrl } = useThreeLiabilityFunction()

async function beforeContactHandle(data: { sn: string; policy_guid: string }) {
  try {
    await showConfirmModal({
      message: `此设备三责险已由极飞代投保（三者险生效时间按极飞出库时间起算) ,可将三责险保单添加到您的账号`,
      className: 'repair-dialog',
      confirmButtonText: '确定添加',
    })
    confirmContactHandle(data)
  } catch (error) {
    console.log('error', error)
  }
}
async function confirmContactHandle(data: { sn: string; policy_guid: string }) {
  // 确认是否要关联
  try {
    showToastLoading()
    await requestContactSnAndThreeLiabilityInsurance({
      ...data,
    })
    showToastSuccess('关联成功')
  } catch (error) {
    commonErrorHandle(error)
  }
  sn.value = ''
}
// 跳转到领取界面
async function toReceive(item: { sn: string; name: string }) {
  const url = await getReceiveThreeLiabilityUrl({
    sn: item.sn,
    name: item.name,
    deviceName: `${item.name}（${item.sn}）`,
    from: 'ruiyun',
  })
  // 去往领取
  // window.open(url)
  window.location.href = url
}
async function searchHandle() {
  showToastLoading()
  try {
    const data = await getSnCanReceiveRuiyunInfo({
      sn: sn.value,
    })
    clearToast()
    if (data?.policy_guid) {
      // 已经投保的，提示用户是否要关联
      beforeContactHandle({
        sn: sn.value,
        policy_guid: data?.policy_guid,
      })
    } else {
      // 跳转领取三责险
      toReceive({
        name: data?.name,
        sn: sn.value,
      })
    }
  } catch (error) {
    clearToast()
    const message = getErrorMessage(error)
    await showConfirmModal({
      message,
      className: 'repair-dialog',
      showCancelButton: false,
      confirmButtonText: '我知道了',
    })
  }
}

function noSearchSnHandle() {
  $router.push({
    name: 'iframe-wrap',
    query: {
      title: '找不到序列号？',
      url: 'https://release-platform.xa.com/app_view_page/help_doc/eb7b7882-29b8-441e-948a-c3cf0d3c0603',
    },
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Header, { title: "免费领取第三者责任险" }),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_unref(Field), {
          class: "field-item",
          placeholder: "请输入",
          clearable: "",
          modelValue: sn.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((sn).value = $event))
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_unref(Button), {
          round: "",
          class: "xa-vant-button",
          onClick: searchHandle
        }, {
          default: _withCtx(() => [
            _createTextVNode("确认")
          ]),
          _: 1
        }),
        _createElementVNode("div", {
          class: "no-search",
          onClick: noSearchSnHandle
        }, "找不到序列号？")
      ])
    ])
  ], 64))
}
}

})